import React, { useMemo, useState } from "react";
import { endOfWeek, startOfWeek } from "./calendar/utils/dates";
import { msToMinutes } from "./calendar/utils";
import { minutes } from "./calendar/utils/types";
import Week from "./calendar/Week";
import { useImmer } from "use-immer";
import { useDialog } from "./Dialog";
import { Empty } from "../utils";

type RawEventData = {
  id: string;
  type: string;
  timeslot: {
    start_time: string;
    end_time: string;
  };
  activity: {
    id: string;
    duration: minutes;
    name: string;
    description: string;
  };
}

type EventData = {
  id: string;
  type: string,
  timeslot: {
    start: Date,
    end: Date,
  };
  activity: {
    id: string;
    duration: minutes;
    name: string;
    description: string;
  };
}

function initializeEventData(eventData: RawEventData[]) : EventData[] {
  return eventData.map((event) => {
    return {
      ...event,
      timeslot: {
        ...event.timeslot,
        start: new Date(Date.parse(event.timeslot.start_time)),
        end: new Date(Date.parse(event.timeslot.end_time)),
      },
    }
  })
}

function toCalendarItemData(eventData: EventData[]) {
  return eventData.map((event) => {
    return {
      itemId: event.id,
      start: new Date(event.timeslot.start),
      duration: msToMinutes(event.timeslot.end.getTime() - event.timeslot.start.getTime()),
    }
  })
}

export const Calendar: React.FC<{
  now?: Date;
  start?: Date;
  end?: Date;
  events?: RawEventData[] | null;
  slotSize?: number;
}> = ({
  now = new Date(),
  start = startOfWeek(now),
  end = endOfWeek(start),
  events = [],
  slotSize = 60,
}) => {
  const data = useMemo(() => initializeEventData(events || []), [events]);
  
  //const [dialogUrl, setDialogUrl] = useImmer<string | undefined>(undefined);
  const [dialogData, setDialogData] = useImmer<EventData | undefined>(undefined);
  const { Dialog, openDialog, closeDialog } = useDialog(
    (new URL(window.location.href)).pathname.endsWith('/new'),
  );

  // const EventItem: ItemContentsType = ({ item }) => {
  //   const eventData = data.find((d) => d.id === item.itemId)
  //   if(!eventData) { return <></> }
  //   return <>
  //   <div
  //     data-testid={`event-${item.start.getTime()}`}
  //     className={`w-full h-full text-xs p-1`} 
  //     onClick={() => {
  //       setDialogData(eventData)
  //       openDialog()
  //     }}
  //   >
  //     {eventData.activity?.name}
  //   </div>
  // </>
  // }

  return <>
    <Week 
      items={toCalendarItemData(data)} 
      slotSize={slotSize}
      start={start}
      end={end}
      // ItemContents={EventItem}
    />
    {dialogData && <Dialog
      CancelButton={Empty}
      ConfirmButton={Empty}
    >
      <div className="w-full h-full flex flex-col">
        <p>{dialogData.activity.name}</p>
        <br />
        <p>{dialogData.activity.description}</p>
        <br />
        <p>{dialogData.timeslot.start.toLocaleDateString()} {dialogData.timeslot.start.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}</p>
      </div>
    </Dialog>}
  </>
}

export default Calendar;